import "./LandingStyles.css";
import { useNavigate } from 'react-router-dom';

function LandingData(props){
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate('/service');
    };
return(
    <div className="h-card">
        <div className="h-icon">
            <i className={props.icon} alt="cards"></i>
        </div>
        <h3>{props.heading}</h3>
        <p>{props.text}</p>
        <button onClick={handleNavigation}>Learn more</button>
    </div>
)
}
export default LandingData;